import { makeAutoObservable } from "mobx"
import { QuestionnarieDetails } from "../interfaces"

const anonimously = "anonimously"

export class QuestionnaireDetailsStore {
	public questionnaireDetails: QuestionnarieDetails | null = null

	constructor() {
		makeAutoObservable(this)
	}

	get isAnonimouslySelected() {
		if (!this.questionnaireDetails || !this.questionnaireDetails.username) {
			return undefined
		}

		return this.questionnaireDetails.username === anonimously
	}

	changeValue(key: keyof QuestionnarieDetails, value: string) {
		if (!this.questionnaireDetails) {
			this.questionnaireDetails = { date: new Date().toISOString() } as QuestionnarieDetails
		}

		this.questionnaireDetails[key] = value
	}
}
